import {useState, useEffect, useContext} from 'react';
import { Box, Typography } from "@mui/material";
import styles from './Home.module.scss';
import PreorderSearch from "./search/PreorderSearch";
import DataTable from "../../components/common/formControls/table/DataTable";
import {useTranslation} from "react-i18next";
import { useAuthentication } from "../../common/requests/LoginRequest";
import { FilterModel, PreOrderData, RowStructure } from '../../common/Interfaces';
import { getPreOrders } from '../../common/requests/PreOrdersRequests';
import { Link } from 'react-router-dom';
import PreOrderStatus from '../../components/preOrderStatus/PreOrderStatus';
import NoDataLabel from '../../components/common/noData/NoDataLabel';
import { GetDateRegional, getMaximumRowsPerPage } from '../../common/Utils';
import AppLoading from '../../components/common/loading/AppLoading';

export default function Home () {
    const {t} = useTranslation();
    const auth = useAuthentication();
    const [preOrders, setPreOrders] = useState<PreOrderData[]>([]);
    const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [filter, setFilter] = useState<FilterModel|undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const obtainsPreOrders = async () => {
        try{
            setIsLoading(true);
            if(auth && auth.sessionData){
                const {data, count} = await getPreOrders(auth.token ?? '', 
                                                      auth.sessionData.ManagementId, 
                                                      auth.sessionData.CompanyId, 
                                                      currentPageIndex,
                                                      !!filter ? [filter!] : undefined);
                setPreOrders(data);
                setTotalCount(count);
            }
        }finally{
            setIsLoading(false);
        }
        
    }

    useEffect(() => {
        if (currentPageIndex >= 0){
            obtainsPreOrders();
        }
    }, [currentPageIndex, filter]);

    const createRows = () => {
        if (preOrders && preOrders.length > 0){
            const rows: RowStructure[] = preOrders.map((preOrder) => ({
                key: `${preOrder.Id}`,
                values: [
                    <Link to={`/preorder/${preOrder.Id}`} target='_blank'>
                        {preOrder.Code}
                    </Link>,
                    <PreOrderStatus preOrder={preOrder}/>,
                    preOrder.Event?.Code ?? <NoDataLabel/>,
                    preOrder.ClientName,
                    preOrder.ProductType?.Name ?? <NoDataLabel/>,
                    preOrder.ProductBrand?.Name ?? <NoDataLabel/>,
                    GetDateRegional(new Date(preOrder.CreationDate)),
                    GetDateRegional(preOrder.Event ? 
                                            new Date(preOrder.Event.ModificationDate ?? preOrder.ModificationDate) : 
                                            new Date(preOrder.ModificationDate)),
                ]
            }));

            return rows;
        } 

        return [];
    }

    return auth.isAuthenticated ? (
        <Box className={styles.container}>
            {isLoading ? 
                (<AppLoading/>) : (
                    <Box className={styles.container}>
                        <PreorderSearch setFiltering={setFilter}/>
                        {!!filter && (
                            <Box className={[styles.horizontalContainer].join(" ")}>
                                <Typography className={styles.normalText}>
                                    <b>{`${t("FILTEREDBY")} ${filter.FriendlyName}:`}</b>
                                </Typography>
                                <Typography className={styles.normalText}>
                                    {`${filter.Value}`}
                                </Typography>
                            </Box>
                        )}
                        <Box className={styles.paddingTop}>
                            <DataTable Headers={[
                                t("PREORDER"),
                                t("STATUS"),
                                t("ORDERCODE"),
                                t("CLIENTNAME"),
                                t("PRODUCTTYPE"),
                                t("BRANDANDSERVICE"),
                                t("CREATIONDATE"),
                                t("LASTUPDATE"),
                                ]}
                                Rows={createRows()}
                                Pagination={{
                                    rowsPerPage: getMaximumRowsPerPage(),
                                    currentPage: currentPageIndex,
                                    setCurrentPage: setCurrentPageIndex,
                                    dataCount: totalCount,
                                }}
                            />
                        </Box>
                    </Box>
                )}
        </Box>
    )
    :
    (<div/>)
    ;
}